export default "__VITE_ASSET__DXwuz7hF__"